var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"settings-modal","size":"lg","centered":"","title":_vm.$t('settings.title')}},[_c('b-tabs',{attrs:{"content-class":"mt-3"}},[_c('profile-tab'),_c('devices-tab'),_c('connection-tab')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }